<template lang="pug">
div
  reservation-preorder-detail-page(:type="type" :mode="mode" :patient-id="patientId" :reservation-id="resolvedReservationId" :origin="$route.params.origin" :origin-data="$route.params.data")
</template>

<script>
import ReservationPreorderDetailPage from '@/components/clinic/reservation-preorder/ReservationPreorderDetailPage.vue'

export default {
  components: { ReservationPreorderDetailPage },
  props: {
    patientId: {
      type: String,
      default: null
    },
    reservationId: {
      type: String,
      default: null
    },
    preorderId: {
      type: String,
      default: null
    }
  },
  computed: {
    type () {
      return ['ClinicPreorderNew', 'ClinicPreorderView'].includes(this.$route.name) ? 'preorder' : 'reservation'
    },
    mode () {
      return ['ClinicReservationView', 'ClinicPreorderView'].includes(this.$route.name) ? 'view' : 'create'
    },
    resolvedReservationId () {
      return this.reservationId || this.preorderId
    }
  },
  beforeDestroy () {
    this.$store.commit('reservationPreorder/resetState')
    this.$store.commit('treatment/resetTreatment')
  }
}
</script>
